import { render, staticRenderFns } from "./CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal.vue?vue&type=template&id=1380ec8e"
import script from "./CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal.vue?vue&type=script&lang=js"
export * from "./CCSendLeadsToDeliveryCampaignWithThrollingDeliveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports